import { render, staticRenderFns } from "./channelPullType.vue?vue&type=template&id=67354c28&scoped=true"
import script from "./channelPullType.vue?vue&type=script&lang=js"
export * from "./channelPullType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67354c28",
  null
  
)

export default component.exports